import { fetchGalleryContent, fetchGalleryPhoto, fetchGalleryVideo } from "../services/api.js";

document.addEventListener("DOMContentLoaded", async () => {
    const gallerySwiperEl = document.querySelector(".gallery-swiper .swiper-wrapper");
    const photoGallerySwiperEl = document.querySelector(".photo-gallery-swiper .swiper-wrapper");
    const videoGallerySwiperEl = document.querySelector(".video-gallery-swiper .swiper-wrapper");
    const contentGallerySwiperEl = document.querySelector(".content-gallery-swiper .swiper-wrapper");
    const filterButtons = document.querySelectorAll(".filter-btn");

    // ================================
    // 🧠 Fetch Data
    // ================================
    if (gallerySwiperEl || photoGallerySwiperEl || videoGallerySwiperEl) {
        var photoData = await fetchGalleryPhoto();
        var videoData = await fetchGalleryVideo();
    }

    if (contentGallerySwiperEl) {
        var contentData = await fetchGalleryContent();
    }
    const photos = photoData || [];
    const videos = videoData || [];

    const allItems = [
        ...photos.map((item) => ({ ...item, type: "photo" })),
        ...videos.map((item) => ({ ...item, type: "video" })),
    ];

    // ================================
    // 🖼️ Render Slides or No Data
    // ================================
    if (gallerySwiperEl) {
        gallerySwiperEl.innerHTML = "";

        if (!allItems.length) {
            gallerySwiperEl.innerHTML = `
        <div class="no-gallery-data text-center w-100 py-5">
          <p class="mb-0 fs-5 fw-semibold text-white">
            <i class="fa-regular fa-image me-2"></i> No photos or videos found.
          </p>
        </div>`;
        } else {
            gallerySwiperEl.innerHTML = allItems
                .map((item) => {
                    const video_id = extractYoutubeID(item?.link);
                    const photodata = item?.data;
                    return `
          <div class="swiper-slide gallery-item" data-type="${item.type}" data-video="${item.link || ""}">
            <div class="gallery-card ${item.type === "video" ? "video-item" : "photo-item"}">
              ${item.type === "photo" && photodata
                            ? `<img src="data:image/png;base64,${photodata}" alt="${item.photo_name || "Photo"}">`
                            : item.type === "video" && video_id
                                ? `<img src="https://i.ytimg.com/vi/${video_id}/maxresdefault.jpg" alt="${item.video_name || "Video"}">`
                                : `<img src="https://placehold.co/300x168" alt="Image">`
                        }
              ${item.type === "video"
                            ? `<div class="play-overlay"><i class="fa-solid fa-play"></i></div>`
                            : ""
                        }
              ${item.type === "photo"
                            ? `<div class="photo-overlay"><i class="fa-solid fa-magnifying-glass-plus"></i></div>`
                            : ""
                        }
            </div>
          </div>`;
                })
                .join("");
        }

        // ================================
        // 🌀 Initialize Swiper
        // ================================
        const gallerySwiper = new Swiper(".gallery-swiper", {
            slidesPerView: 1,
            spaceBetween: 20,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".gallery-swiper .swiper-button-next",
                prevEl: ".gallery-swiper .swiper-button-prev",
            },
            breakpoints: {
                992: { slidesPerView: 4 },
                768: { slidesPerView: 2 },
                576: { slidesPerView: 1 },
            },
        });

        // ================================
        // 🎛️ Filter Logic with “No Results” Handling
        // ================================
        const slides = document.querySelectorAll(".gallery-item");

        filterButtons.forEach((btn) => {
            btn.addEventListener("click", () => {
                const filter = btn.getAttribute("data-filter");

                filterButtons.forEach((b) => b.classList.remove("active"));
                btn.classList.add("active");

                const oldMsg = document.querySelector(".no-gallery-message");
                if (oldMsg) oldMsg.remove();

                let visibleCount = 0;

                slides.forEach((slide) => {
                    const type = slide.getAttribute("data-type");
                    if (filter === "all" || filter === type) {
                        slide.style.display = "flex";
                        visibleCount++;
                    } else {
                        slide.style.display = "none";
                    }
                });

                if (visibleCount === 0) {
                    const message = document.createElement("div");
                    message.className = "no-gallery-message text-center w-100 py-4";
                    message.innerHTML = `
            <p class="mb-0 text-white fw-semibold">
              <i class="fa-regular fa-image me-2"></i>
              ${filter === "photo"
                            ? "No photos found."
                            : filter === "video"
                                ? "No videos found."
                                : "No items found."
                        }
            </p>`;
                    gallerySwiperEl.appendChild(message);
                }

                setTimeout(() => gallerySwiper.update(), 200);
            });
        });
    }

    if (photoGallerySwiperEl) {
        photoGallerySwiperEl.innerHTML = "";

        if (!photoData.length) {
            photoGallerySwiperEl.innerHTML = `
        <div class="no-gallery-data text-center w-100 py-5">
          <p class="mb-0 fs-5 fw-semibold text-white">
            <i class="fa-regular fa-image me-2"></i> No photos or videos found.
          </p>
        </div>`;
        } else {
            photoGallerySwiperEl.innerHTML = photoData
                .map((item) => {
                    const photodata = item?.data;
                    return `
                    <div class="swiper-slide gallery-item" data-type="${item.type}" data-video="${item.link || ""}">
                        <div class="gallery-card photo-item">
                        <img src="data:image/png;base64,${photodata}" alt="${item.photo_name || "Photo"}">
                                    <div class="photo-overlay"><i class="fa-solid fa-magnifying-glass-plus"></i></div>
                        </div>
                    </div>`;
                })
                .join("");
        }

        // ================================
        // 🌀 Initialize Swiper
        // ================================
        new Swiper(".photo-gallery-swiper", {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".photo-gallery-swiper .swiper-button-next",
                prevEl: ".photo-gallery-swiper .swiper-button-prev",
            },
            breakpoints: {
                992: { slidesPerView: 4 },
                768: { slidesPerView: 2 },
                576: { slidesPerView: 1 },
            },
        });
    }

    if (videoGallerySwiperEl) {
        videoGallerySwiperEl.innerHTML = "";

        if (!videoData.length) {
            videoGallerySwiperEl.innerHTML = `
        <div class="no-gallery-data text-center w-100 py-5">
          <p class="mb-0 fs-5 fw-semibold text-white">
            <i class="fa-regular fa-image me-2"></i> No videos found.
          </p>
        </div>`;
        } else {
            videoGallerySwiperEl.innerHTML = videoData
                .map((item) => {
                    const photodata = item?.data;
                    const video_id = extractYoutubeID(item?.link);
                    return `
                    <div class="swiper-slide gallery-item" data-type="${item.type}" data-video="${item.link || ""}">
                        <div class="gallery-card video-item">
                        <img src="https://i.ytimg.com/vi/${video_id}/maxresdefault.jpg" alt="${item.video_name || "Video"}">
                        <div class="play-overlay"><i class="fa-solid fa-play"></i></div>
                        </div>
                    </div>`;
                })
                .join("");
        }

        // ================================
        // 🌀 Initialize Swiper
        // ================================
        new Swiper(".video-gallery-swiper", {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".video-gallery-swiper .swiper-button-next",
                prevEl: ".video-gallery-swiper .swiper-button-prev",
            },
            breakpoints: {
                992: { slidesPerView: 4 },
                768: { slidesPerView: 2 },
                576: { slidesPerView: 1 },
            },
        });
    }

    if (contentGallerySwiperEl) {
        contentGallerySwiperEl.innerHTML = "";

        if (!videoData.length) {
            contentGallerySwiperEl.innerHTML = `
        <div class="no-gallery-data text-center w-100 py-5">
          <p class="mb-0 fs-5 fw-semibold text-white">
            <i class="fa-regular fa-image me-2"></i> No videos found.
          </p>
        </div>`;
        } else {
            contentGallerySwiperEl.innerHTML = contentData
                .map((item) => {
                    const photodata = item?.data;
                    const video_id = extractYoutubeID(item?.link);
                    return `
                    <div class="swiper-slide gallery-item" data-type="${item.type}" data-video="${item.link || ""}">
                        <div class="gallery-card video-item">
                        <img src="https://i.ytimg.com/vi/${video_id}/maxresdefault.jpg" alt="${item.video_name || "Video"}">
                        <div class="play-overlay"><i class="fa-solid fa-play"></i></div>
                        </div>
                    </div>`;
                })
                .join("");
        }

        // ================================
        // 🌀 Initialize Swiper
        // ================================
        new Swiper(".content-gallery-swiper", {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".content-gallery-swiper .swiper-button-next",
                prevEl: ".content-gallery-swiper .swiper-button-prev",
            },
            breakpoints: {
                992: { slidesPerView: 4 },
                768: { slidesPerView: 2 },
                576: { slidesPerView: 1 },
            },
        });
    }

    // ================================
    // 🎥 Modal Popup for Video
    // ================================
    let photoItems = [...document.querySelectorAll(".photo-item img")].map(img => img.src);
    let videoItems = [...document.querySelectorAll(".video-item")].map(el => el.closest(".gallery-item").dataset.video);

    let currentPhotoIndex = 0;
    let currentVideoIndex = 0;


    const modalHTML = `
    <div class="video-modal" id="videoModal">
    <div class="video-backdrop"></div>
    <div class="video-content">
        <button class="video-close"><i class="fa-solid fa-xmark"></i></button>
        <button class="video-prev nav-btn"><i class="fa-solid fa-chevron-left"></i></button>
        <button class="video-next nav-btn"><i class="fa-solid fa-chevron-right"></i></button>
        <div class="video-frame-container">
        <iframe id="videoFrame" width="100%" height="100%" frameborder="0" allow="autoplay" allowfullscreen></iframe>
        </div>
    </div>
    </div>`;

    document.body.insertAdjacentHTML("beforeend", modalHTML);

    const modal = document.getElementById("videoModal");
    const iframe = document.getElementById("videoFrame");
    const closeBtn = modal.querySelector(".video-close");
    const backdrop = modal.querySelector(".video-backdrop");

    document.querySelectorAll(".video-item").forEach((videoCard, index) => {
    videoCard.addEventListener("click", () => {

        currentVideoIndex = index;
        showVideo(currentVideoIndex);

        modal.classList.add("active");
        document.body.style.overflow = "hidden";
    });
});

function showVideo(idx) {
    iframe.src = videoItems[idx] + "&autoplay=1";
}


    function closeModal() {
        modal.classList.remove("active");
        iframe.src = "";
        document.body.style.overflow = "";
    }

    closeBtn.addEventListener("click", closeModal);
    backdrop.addEventListener("click", closeModal);

    document.querySelector(".video-next").addEventListener("click", () => {
    currentVideoIndex = (currentVideoIndex + 1) % videoItems.length;
    showVideo(currentVideoIndex);
});

document.querySelector(".video-prev").addEventListener("click", () => {
    currentVideoIndex = (currentVideoIndex - 1 + videoItems.length) % videoItems.length;
    showVideo(currentVideoIndex);
});


    // ================================
    // 🖼️ Modal Popup for Photo
    // ================================
    const photoModalHTML = `
<div class="photo-modal" id="photoModal">
  <div class="photo-backdrop"></div>
  <div class="photo-content">
    <button class="photo-close"><i class="fa-solid fa-xmark"></i></button>

    <button class="photo-prev nav-btn"><i class="fa-solid fa-chevron-left"></i></button>
    <button class="photo-next nav-btn"><i class="fa-solid fa-chevron-right"></i></button>

    <img id="photoPreview" src="" />
</div>
</div>`;

    document.body.insertAdjacentHTML("beforeend", photoModalHTML);

    const photoModal = document.getElementById("photoModal");
    const photoImg = document.getElementById("photoPreview");
    const photoClose = photoModal.querySelector(".photo-close");
    const photoBackdrop = photoModal.querySelector(".photo-backdrop");

    document.querySelectorAll(".photo-item").forEach((photo, index) => {
    photo.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        currentPhotoIndex = index;
        showPhoto(currentPhotoIndex);

        photoModal.classList.add("active");
        document.body.style.overflow = "hidden";
    });
});

function showPhoto(idx) {
    photoImg.src = photoItems[idx];
}


    function closePhotoModal() {
        photoModal.classList.remove("active");
        photoImg.src = "";
        document.body.style.overflow = "";
    }

    photoClose.addEventListener("click", closePhotoModal);
    photoBackdrop.addEventListener("click", closePhotoModal);

    document.querySelector(".photo-next").addEventListener("click", () => {
    currentPhotoIndex = (currentPhotoIndex + 1) % photoItems.length;
    showPhoto(currentPhotoIndex);
    });

    document.querySelector(".photo-prev").addEventListener("click", () => {
        currentPhotoIndex = (currentPhotoIndex - 1 + photoItems.length) % photoItems.length;
        showPhoto(currentPhotoIndex);
    });


    // ================================
    // 🔧 Helper
    // ================================
    function extractYoutubeID(urlString) {
        const match = urlString?.match(/embed\/(.*?)\?/);
        return match ? match[1] : null;
    }

// ================================
// 📌 Inject Modal Prev/Next Button CSS
// ================================
const modalNavCSS = `
.nav-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 9999;
    background: rgba(0,0,0,0.6);
    border: none;
    color: #fff;
    width: 48px;
    height: 48px;
    font-size: 22px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.25s ease;
}

/* Safe inside modal */
.photo-prev,
.video-prev {
    left: 10px;
}

.photo-next,
.video-next {
    right: 10px;
}

.nav-btn:hover {
    background: rgba(255,255,255,0.35);
}

.photo-content,
.video-content {
    position: relative !important;
}

`;

const styleTag = document.createElement("style");
styleTag.innerHTML = modalNavCSS;
document.head.appendChild(styleTag);

});
